import { consentItems } from '@/mocks/surveyData';
import { useSurvey } from '../hooks/useSurvey';

interface ConsentScreenProps {
  survey: ReturnType<typeof useSurvey>;
}

export default function ConsentScreen({ survey }: ConsentScreenProps) {
  const { answers, updateConsent, submitError } = survey;

  const requiredChecked = consentItems
    .filter((item) => item.required)
    .every((item) => answers[item.id] === true);

  return (
    <div className="flex flex-col gap-6">
      <div>
        <h3 className="text-base font-semibold text-text-primary mb-1">약관 동의</h3>
        <p className="text-xs text-text-secondary">
          서비스 이용을 위해 아래 동의가 필요해요
        </p>
      </div>

      <div className="flex flex-col gap-3">
        {consentItems.map((item) => (
          <label
            key={item.id}
            className={`flex items-center gap-3 p-4 rounded-xl border-2 transition-all duration-200 cursor-pointer ${
              answers[item.id]
                ? 'border-coral bg-coral-light'
                : 'border-border-color bg-white hover:border-coral/40'
            }`}
          >
            <div
              className={`w-5 h-5 rounded flex items-center justify-center flex-shrink-0 transition-all duration-200 ${
                answers[item.id]
                  ? 'bg-coral border-coral'
                  : 'border-2 border-border-color bg-white'
              }`}
            >
              {answers[item.id] && (
                <i className="ri-check-line text-white text-xs font-bold" />
              )}
            </div>
            <div className="flex-1 min-w-0">
              <span className="text-sm font-medium text-text-primary">
                {item.label}
              </span>
            </div>
            <span className={`text-xs font-medium flex-shrink-0 ${item.required ? 'text-coral' : 'text-text-secondary'}`}>
              {item.required ? '[필수]' : '[선택]'}
            </span>
            <input
              type="checkbox"
              checked={answers[item.id] === true}
              onChange={(e) => updateConsent(item.id, e.target.checked)}
              className="hidden"
            />
          </label>
        ))}
      </div>

      {!requiredChecked && (
        <p className="text-coral text-xs font-medium text-center">
          필수 동의 항목을 모두 체크해주세요
        </p>
      )}

      {submitError && (
        <div className="bg-coral-light border border-coral rounded-xl px-4 py-3">
          <p className="text-coral text-sm font-medium text-center">{submitError}</p>
        </div>
      )}
    </div>
  );
}